import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Drop = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M19.5 14.056c0 3.973-3.246 7.194-7.25 7.194S5 18.03 5 14.056C5 9.9 8.916 5.385 10.992 3.282a1.75 1.75 0 0 1 2.516 0c2.076 2.103 5.992 6.62 5.992 10.774'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.791 2.755a2.5 2.5 0 0 0-3.582 0c-1.057 1.07-2.594 2.766-3.87 4.737C5.071 9.446 4 11.762 4 14.056 4 18.449 7.587 22 12 22s8-3.551 8-7.944c0-2.294-1.072-4.61-2.338-6.564-1.277-1.971-2.814-3.667-3.87-4.737'
        fill='currentColor'
      />
    )}
  </IconBase>
);
